// extracted by mini-css-extract-plugin
export default {"sliderHeadingAndValue":"Slider_sliderHeadingAndValue__sSxUp","heading":"Slider_heading__EVXIB","value":"Slider_value__Z+aBm","slider":"Slider_slider__exImE"};